import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {Principal, User} from '../princial.service';
import {LanguageService} from '../../language.service';
import {StageService} from "../../service/stage.service";
import {MatToolbar} from "@angular/material/toolbar";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {UserComponent} from "./user/user.component";
import {MsalBroadcastService, MsalService} from "@azure/msal-angular";
import {InteractionStatus} from "@azure/msal-browser";
import {filter, Subject, takeUntil} from "rxjs";

@Component({
  selector: 'roaming-ui-component-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  imports: [
    MatToolbar,
    RouterLink,
    RouterLinkActive,
    TranslatePipe,
    MatButton,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    UserComponent,
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  username: string = '';
  authorities: string[] = [];
  userData: User | null = null;
  selectedLanguage: string = 'DE';
  stage: string = '';
  private readonly _destroying$ = new Subject<void>();
  private _authenticatedDataLoaded = false;

  languageDisplayMap: { [key: string]: string } = {
    en: 'EN',
    de: 'DE',
  };

  constructor(
      private readonly principal: Principal,
      private readonly translate: TranslateService,
      private readonly languageService: LanguageService,
      private readonly stageService: StageService,
      private readonly _cdr: ChangeDetectorRef,
      private readonly authService: MsalService,
      private readonly msalBroadcastService: MsalBroadcastService
  ) {
  }

  ngOnInit(): void {
    this.translate.setDefaultLang('de');

    this.msalBroadcastService.inProgress$
    .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
    )
    .subscribe(() => this.loadAuthenticatedDataIfAccountExists());

    this.loadAuthenticatedDataIfAccountExists();
  }

  private loadAuthenticatedDataIfAccountExists(): void {
    if (this._authenticatedDataLoaded) {
      return;
    }

    if (!this.authService.instance.getActiveAccount() && this.authService.instance.getAllAccounts().length > 0) {
      this.authService.instance.setActiveAccount(this.authService.instance.getAllAccounts()[0]);
    }

    if (!this.authService.instance.getActiveAccount()) {
      return;
    }

    this._authenticatedDataLoaded = true;
    this.principal.getUser().then((user) => {
      this.username = user.name;
      this.authorities = user.authorities;
      this.userData = user;
      this._cdr.detectChanges();
    });
    this.getStages();
  }

  getStages(): void {
    this.stageService.getStage().subscribe((stage) => {
      this.stage = stage;
      this._cdr.detectChanges();
    });
  }

  changeLanguage(language: string) {
    this.languageService.setLanguage(language);
    this.selectedLanguage = this.languageDisplayMap[language];
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}
